import subFranchises from "../../api/subFranchises";

export default {
  namespaced: true,
  state: {
    items: [],
    editedId: -1,
    editedItem: {
      name: "",
      updatedAt: null,
      updatedBy: null,
    },
    defaultItem: {
      name: "",
      updatedAt: null,
      updatedBy: null,
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      const editedItem = {
        name: item.name,
        updatedAt: item.updatedAt,
        updatedBy: item.updatedBy,
      };
      state.editedItem = editedItem;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return subFranchises.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    saveEditedItem({ dispatch, state }) {
      return subFranchises.store(state.editedItem).then((response) => {
        dispatch("fetchAll");
        dispatch("resetEditedItem");
        return response;
      });
    },
    updateEditedItem({ dispatch, state }) {
      return subFranchises
        .update(state.editedId, state.editedItem)
        .then((response) => {
          dispatch("fetchAll");
          dispatch("resetEditedItem");
          return response;
        });
    },
    deleteItem(context, id) {
      return subFranchises.delete(id);
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
